import {
    userRequest,
    userSuccess,
    userAddSuccess,
    userEditSuccess,
    userError,
    getUserByIdRequest,
    getUserByIdSuccess,
    getUserByIdError,
  } from "./reducer";
  
  import {
    getAllUser,
    addUser,
    updateUser,
    getUserById,
    changePassword
  } from "../../../helpers/backend_helper";
  
  export const fetchUsers = (page:number,count:number,keyword:string) => async (dispatch: any) => {
    dispatch(userRequest());
    try {
      const response: any = await getAllUser(page,count,keyword);
      if (response && response.data) {
        dispatch(userSuccess(response.data.data));
        return response
      } else {
        dispatch(userError("Failed to fetch users"));
      }
    } catch (error: any) {
      dispatch(userError(error.message));
    }
  };
  
  export const addNewUser = (userData: any) => async (dispatch: any) => {
    dispatch(userRequest());
    try {
      const response: any = await addUser(userData);
      if (response) {
        dispatch(userAddSuccess(response.data));
        return response 
      } else {
        dispatch(userError("Failed to add user"));
      }
    } catch (error: any) {
      dispatch(userError(error.message));
    }
  };
  
  export const editUser = (updatedData: any) => async (dispatch: any) => {
    dispatch(userRequest());
    try {
      const response: any = await updateUser(updatedData);
      if (response && response.data) {
        dispatch(userEditSuccess(response.data));
      } else {
        dispatch(userError("Failed to edit user"));
      }
    } catch (error: any) {
      dispatch(userError(error.message));
    }
  };
 
  export const fetchUserById = (userId: string) => async (dispatch: any) => {
    dispatch(getUserByIdRequest());
    try {
      const response: any = await getUserById(userId);  
  
      if (response && response.isSuccess) {
        dispatch(getUserByIdSuccess(response.data)); 
        return response;  // ✅ Yeh return hoga component me
      } else {
        dispatch(getUserByIdError("Failed to fetch user by ID"));
        return null; // ❌ ya koi default value, taake calling component handle kar sake
      }
    } catch (error: any) {
      dispatch(getUserByIdError(error.message));  
      return null;
    }
  };

  export const updatePassword = (data:any) => async (dispatch: any) => {
    dispatch(userRequest());
    try {
      const response: any = await changePassword(data);
      if (response && response.isSuccess) {
        dispatch(userEditSuccess(response.data));
        return response;
      } else {
        dispatch(userError("Failed to change password"));
        return response;
      }
    } catch (error: any) {
      dispatch(userError(error.message));
      return null;
    }
  }
  
//   // DELETE USER
//   export const removeUser = (userId: string) => async (dispatch: any) => {
//     dispatch(userRequest());
//     try {
//       const response: any = await deleteUser(userId);
//       if (response && response.isSuccess) {
//         dispatch(userDeleteSuccess(userId));
//       } else {
//         dispatch(userError("Failed to delete user"));
//       }
//     } catch (error: any) {
//       dispatch(userError(error.message));
//     }
//   };
  